/**
 * VipBadge.js — the one place the VIP badge label is defined.
 *
 * An active VIP who has opted out of auto-renewal reads "VIP - NOT RENEWING"
 * instead of plain "VIP", so staff can spot them and handle them accordingly.
 * Colors are intentionally unchanged from each badge's existing styling —
 * callers pass their own `style` and only the text varies.
 *
 * ⚠️ The underlying flag is `vip_memberships.auto_renew` (false = opted out).
 * That column was inverted repo-wide until 2026-08-12 because the production
 * API's `doNotRenewal` field means the OPPOSITE of its name — see the comment
 * in netlify/functions/sync-vip-scheduled.js before trusting either one.
 * Real opt-outs are ~220 of ~6,200 active members (~3.5%); if this badge ever
 * starts showing on nearly every VIP, the flag has flipped again.
 */

export const VIP_LABEL = 'VIP';
export const VIP_NOT_RENEWING_LABEL = 'VIP - NOT RENEWING';

/** Text for a VIP badge. */
export function vipLabel(notRenewing) {
  return notRenewing ? VIP_NOT_RENEWING_LABEL : VIP_LABEL;
}

/** Hover text explaining the state. */
export function vipTitle(notRenewing) {
  return notRenewing
    ? 'Active VIP Club member who has opted OUT of auto-renewal'
    : 'Active VIP Club member';
}

/**
 * Renders a VIP badge. Pass the caller's existing inline style so each surface
 * keeps the look it already had; only the label changes for non-renewers.
 */
export default function VipBadge({ notRenewing = false, style, className }) {
  return (
    <span
      className={className}
      title={vipTitle(notRenewing)}
      style={{ whiteSpace: 'nowrap', ...style }}
    >
      {vipLabel(notRenewing)}
    </span>
  );
}
